module.exports = __webpack_public_path__ + "img/logo-salvedomi.8a2f009c.svg";